/*
 * @Author: lzy 
 * @Date: 2021-01-04 16:47:53
 * @LastEditTime: 2021-10-28 15:44:11
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\editingCenter\trill\service\initTrillEditerBtnService.js
 * @Description: 抖音渠道公共服务
 */

'use strict';
angular.module('initTrillEditerBtnServiceModule', []).factory('initTrillEditerBtnService', ['$q', 'editIsLock', 'editcenterRightsService',
    function ($q, editIsLock, editcenterRightsService) {

        /**
         * [initBtnRights description] 初始化权限
         *
         * @param  {[type]}  platform   [platform description]
         * @param  {[type]}  account   [account description]
         *
         * @return  {[type]}   [return description]
         */
        function initBtnRights(platform, account) {
            const rightsParams = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryOperKeyOfDouYin',
                Classify: ['douyin.daibian', 'douyin.daishen'][platform],
                douYinAccountId: account,
            };
            return editcenterRightsService.initListBtn(rightsParams);
        }
        return {
            initTrillEditerBtn: function (platform, account) {
                var defer = $q.defer();
                var compileArrays = [{
                    'RIGHTINDEX': 804,
                    'OPERDESC': '保存',
                    'OPERFUN': 'save'
                }, {
                    'RIGHTINDEX': 805,
                    'OPERDESC': '送审',
                    'OPERFUN': 'trillTrial',
                    'rightKey': 'douyin.daibian.songshen'
                }, {
                    'RIGHTINDEX': 806,
                    'OPERDESC': '签发',
                    'OPERFUN': 'trillSign',
                    'rightKey': 'douyin.daibian.qianfa'
                }
                ];
                var pendingArrays = [{
                    'RIGHTINDEX': 804,
                    'OPERDESC': '保存',
                    'OPERFUN': 'save'
                }, {
                    'RIGHTINDEX': 807,
                    'OPERDESC': '撤稿',
                    'OPERFUN': 'trillKill',
                    'rightKey': 'douyin.daishen.chegao'
                }, {
                    'RIGHTINDEX': 808,
                    'OPERDESC': '签发',
                    'OPERFUN': 'trillSign',
                    'rightKey': 'douyin.daishen.qianfa'
                }];
                var arrayWebsiteBtns = [compileArrays, pendingArrays];
                initBtnRights(platform, account).then(function (rights) {
                    var btns = arrayWebsiteBtns[platform];
                    defer.resolve(btns.filter(function (btn) {
                        return !btn.rightKey || rights[btn.rightKey];
                    }));
                });
                return defer.promise;
            },

            /**
             * [trillEditor description] 进入编辑页
             * @param   {[type]}  account     [account description]
             * @param   {[type]}  articleid   [articleid description]
             * @param   {[type]}  platform    [platform description]
             * @return  {function}            [return description]
             */
            trillEditor: function (account, articleid, platform) {
                var routerName = `#/trillnews?accountid=${account}&platform=${platform}`;
                // if (isOriginal) {
                //     routerName += `&isOriginal=${isOriginal}`;
                // }
                if (articleid) {
                    routerName += `&douyinarticleid=${articleid}`;
                    editIsLock.isLock({ METADATAID: articleid }, 17).then(function (data) {
                        if (data.ISLOCK === 'false') {
                            window.open(routerName);
                        } else {
                            editIsLock.checkUnlockPermissions({ METADATAID: articleid }, data).then(function () {
                                window.open(routerName);
                            });
                        }
                    });
                } else {
                    window.open(routerName);
                }
            }
        };
    }
]);
